import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Disable automatic browser scroll restoration so that page refresh on desktop/mobile
// always starts at the top hero section rather than jumping to previous middle/footer position
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If no specific hash link is targeted, force immediate scroll to top
    if (!hash) {
      window.scrollTo(0, 0);

      // Secondary RAF check to override any delayed browser scroll restoration
      const raf = requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });
      return () => cancelAnimationFrame(raf);
    }
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
